import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import ALL available translation files
import sq from './locales/sq/translation.json';
import en from './locales/en/translation.json';
import tr from './locales/tr/translation.json';
import uz from './locales/uz/translation.json';
import ru from './locales/ru/translation.json';

// Map of all available locales
const ALL_LOCALES = { sq, en, tr, uz, ru };

// Read language config from runtime config.js
const langConfig = window.__UMS_THEME__?.languages || {
  lng1: { locale: 'sq', name: 'Shqip' },
  lng2: { locale: 'en', name: 'English' },
  lng3: { locale: 'tr', name: 'T\u00FCrk\u00E7e' }
};
const defaultLang = window.__UMS_THEME__?.defaultLanguage || 'lng1';

// Dynamically map configured locales to lng1/lng2/lng3 slots
const resources = {
  lng1: { translation: ALL_LOCALES[langConfig.lng1?.locale] || sq },
  lng2: { translation: ALL_LOCALES[langConfig.lng2?.locale] || en },
};
// Only add lng3 if configured (supports 2-language universities)
if (langConfig.lng3) {
  resources.lng3 = { translation: ALL_LOCALES[langConfig.lng3?.locale] || tr };
}

// Override languageLNG labels from config so t("languageLNG1") shows the configured language name
Object.keys(resources).forEach((slot) => {
  const orig = resources[slot].translation;
  resources[slot].translation = {
    ...orig,
    ...(langConfig.lng1?.name && { languageLNG1: `(${langConfig.lng1.name})` }),
    ...(langConfig.lng2?.name && { languageLNG2: `(${langConfig.lng2.name})` }),
    ...(langConfig.lng3?.name && { languageLNG3: `(${langConfig.lng3.name})` }),
  };
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: ['i18next', 'lang'],
      caches: ['localStorage', 'cookie'],
      lowerCaseLng: true,
    },
    fallbackLng: defaultLang,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
